import { createElement } from 'react';
import MaterialSelectField from 'components/MaterialSelectField';
import MenuItem from 'material-ui/MenuItem';
import { map, find, propEq, is } from 'ramda';

import { colors } from 'styles/provider';

import { edit, view } from './SelectField.less';

const findOptionLocale = (value, options, localeMessage, idAccessor) => {
  const opt = find(propEq('value', value), options);
  if (!opt || !is(Object, opt)) return '';

  return (opt.label && localeMessage(opt.label)) || localeMessage(idAccessor ? idAccessor(opt.value) : opt.value);
};

const mapOptions = (localeMessage, idAccessor, rawValues) => option => {
  return createElement(MenuItem, {
    value: option.value,
    key: option.value,
    primaryText: rawValues
      ? option.value
      : option.label
        ? localeMessage(option.label)
        : localeMessage(idAccessor ? idAccessor(option.value) : option.value),
  });
};

const SelectField = ({
  editing,
  input,
  meta,
  localeMessage,
  hintLocale,
  formValues,
  options = [],
  optionFormatter,
  rawValues = false,
  ...other
}) => {
  return editing
    ? createElement(
        MaterialSelectField,
        {
          className: edit,
          value: input.value,
          onChange: (e, i, v) => input.onChange(v),
          hintText: hintLocale && localeMessage(hintLocale),
          hintStyle: { color: colors.clrLabelLight, fontStyle: 'italic' },
          ...other,
        },
        map(mapOptions(localeMessage, optionFormatter, rawValues), options),
      )
    : createElement('div', { className: view }, findOptionLocale(input.value, options, localeMessage, optionFormatter));
};

export default SelectField;
